import React from 'react';
import AnimatedElement from '../components/AnimatedElement.js';

const HeroSection = () => (
    <section id="hero" className="h-screen w-screen flex-shrink-0 flex items-center justify-right p-0 md:p-0 bg-brand-black relative ">
        <div className="flex flex-col md:flex-row items-center justify-between w-full max-w-7xl">
        <div className="hidden right-0 md:block relative w-1/2 h-full shrink-0 overflow-hidden m-10">
        <img src=".\assets\img\ax-site-final4.png" alt="Won J. You" className="p-5 m-0 w-full h-full object-cover object-left hidden md:block" />
                {/* <div className="mt-1 w-full h-2 rounded-full bg-red-600 shadow-[0_0_12px_#ff0000,0_0_25px_#ff3333,0_4px_8px_rgba(0,0,0,0.5)]"></div> */}

            </div>
            <div className="z-10 w-full md:w-3/5 m-0 p-0">
                <AnimatedElement className="text-brand-red  uppercase text-5xl sm:text-6xl md:text-7xl lg:text-8xl !leading-none tracking-tighter  m-0 p-0">
                    <span className="block justify-center" style={{ fontFamily: 'pinar', color: '#FFFFFF',fontSize: "clamp(26px, 7vw, 60px)", lineHeight: "1.4"}}>بـرند واقـعی در</span>
                    <span className="block justify-center" style={{ fontFamily: 'pinar', color: '#ff2a3f' ,fontSize: "clamp(26px, 7vw, 60px)", lineHeight: "1.4"}}>ذهـــن مـخاطب</span>
                    <span className="block justify-center" style={{ fontFamily: 'pinar', color: '#FFFFFF', fontSize: "clamp(26px, 7vw, 60px)", lineHeight: "1.4"}}>ساختـه می شود</span>
                    <span className="block justify-center" style={{ fontFamily: 'pinar' ,color: '#ff2a3f' ,fontSize: "clamp(26px, 7vw, 60px)", lineHeight: "1.4"}}>نــه در لـــــوگـو</span>


                </AnimatedElement>
                <p className="text-lg md:text-xl leading-relaxed  " style={{ fontFamily: 'pinar' ,color: '#FFFFFF' ,fontSize: "clamp(15px, 2.4vw, 18px)", lineHeight: "1.8"}}>استراتژی ، هویت و روایت عناصر اصلی ساخت برندهای متمایز</p>

                <AnimatedElement className="mt-8" delay="duration-1000">
                    {/* <p className="text-lg md:text-xl text-brand-cream">Design mentorship<br/>by Won J. You</p> */}
                </AnimatedElement>
            </div>
        
        </div>
        <div className="absolute bottom-8 left-8 md:left-1/2 md:-translate-x-1/2 text-brand-cream opacity-50 text-sm">SCROLL TO DISCOVER &rarr;</div>
    </section>
);

export default HeroSection;
